import auth from 'api/auth'
import cookies from 'utilities/cookies'
import * as namedTypes from '../namespaced-mutation-types'
import * as types from '../mutation-types'

export const setUserAuthTouchTimestamp = ({ commit }) => {
  commit(types.USER_AUTH_TOUCH_TIMESTAMP, Date.now())
}
export const setCompanyAuthTouchTimestamp = ({ commit }) => {
  commit(types.COMPANY_AUTH_TOUCH_TIMESTAMP, Date.now())
}
export const showLoginAlert = ({ commit }, data) => {
  commit(types.TOGGLE_LOGIN_ALERT, data)
}
export const showLoginModal = ({ commit }) => {
  commit(types.TOGGLE_LOGIN_MODAL, true)
}
export const dismissLoginModal = ({ commit }) => {
  commit(types.TOGGLE_LOGIN_MODAL, false)
}

export const toggleLoginModal = ({ commit, state }, toggle) => {
  if (typeof toggle !== 'undefined') {
    commit(types.TOGGLE_LOGIN_MODAL, !!toggle)
  } else {
    if (state.toggleLoginModal === false) {
      commit(types.TOGGLE_LOGIN_MODAL, true)
    } else {
      commit(types.TOGGLE_LOGIN_MODAL, false)
    }
  }
}

export const toggleMenuSidebar = ({ commit, state }, toggle) => {
  if (typeof toggle !== 'undefined') {
    commit(types.TOGGLE_MENU_SIDEBAR, !!toggle)
  } else {
    if (state.toggleMenuSidebar === false) {
      commit(types.TOGGLE_MENU_SIDEBAR, true)
    } else {
      commit(types.TOGGLE_MENU_SIDEBAR, false)
    }
  }
}

export const toggleUserSidebar = ({ commit, state }, toggle) => {
  if (typeof toggle !== 'undefined') {
    commit(types.TOGGLE_USER_SIDEBAR, !!toggle)
  } else {
    if (state.toggleUserSidebar === false) {
      commit(types.TOGGLE_USER_SIDEBAR, true)
    } else {
      commit(types.TOGGLE_USER_SIDEBAR, false)
    }
  }
}

export const companiesLoadingTimeout = ({ commit }, loading) => {
  if (typeof loading !== 'undefined') {
    commit(types.COMPANIES_LOADING_TIMEOUT, loading)
  } else {
    commit(types.COMPANIES_LOADING_TIMEOUT, undefined)
  }
}

export const companiesLoading = ({ commit }, loading) => {
  if (typeof loading !== 'undefined') {
    commit(types.COMPANIES_LOADING, loading)
  } else {
    commit(types.COMPANIES_LOADING, undefined)
  }
}

export const vacanciesLoadingTimeout = ({ commit }, loading) => {
  if (typeof loading !== 'undefined') {
    commit(types.VACANCIES_LOADING_TIMEOUT, loading)
  } else {
    commit(types.VACANCIES_LOADING_TIMEOUT, undefined)
  }
}

export const vacanciesLoading = ({ commit }, loading) => {
  if (typeof loading !== 'undefined') {
    commit(types.VACANCIES_LOADING, loading)
  } else {
    commit(types.VACANCIES_LOADING, undefined)
  }
}

export const resetPassword = ({ commit }, payload) => {
  commit(namedTypes.USER_DATA, {}, { root: true })
  commit(namedTypes.USER_TOKEN, '', { root: true })
  cookies.remove('debutToken')
  try {
    window.sessionStorage.removeItem('debutToken')
    window.sessionStorage.removeItem('debutUserData')
  } catch (e) {}

  commit(namedTypes.MANIPULATOR_DATA, {}, { root: true })
  commit(namedTypes.MANIPULATOR_TOKEN, '', { root: true })
  cookies.remove('debutManipulatorToken')
  try {
    window.sessionStorage.removeItem('debutManipulatorToken')
    window.sessionStorage.removeItem('debutManipulatorData')
  } catch (e) {}

  return auth.resetPassword(payload).then((data) => {
    if (typeof data.user.manipulator !== 'undefined' &&
      data.user.manipulator === true
    ) {
      commit(namedTypes.MANIPULATOR_DATA, data.user, { root: true })
      commit(namedTypes.MANIPULATOR_TOKEN, data.token, { root: true })
      cookies.set('debutManipulatorToken', data.token, { expires: 86400 })
    } else {
      commit(namedTypes.USER_DATA, data.user, { root: true })
      commit(namedTypes.USER_TOKEN, data.token, { root: true })
      cookies.set('debutToken', data.token, { expires: 86400 })
    }
    return Promise.resolve(data)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const showUserEditResumeTextareaDialog = ({ commit }) => {
  commit(types.TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG, true)
}

export const dismissUserEditResumeTextareaDialog = ({ commit }) => {
  commit(types.TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG, false)
}

export const toggleUserEditResumeTextareaDialog = ({ commit, state }, toggle) => {
  if (typeof toggle !== 'undefined') {
    commit(types.TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG, !!toggle)
  } else {
    if (state.toggleUserEditResumeTextareaDialog === false) {
      commit(types.TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG, true)
    } else {
      commit(types.TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG, false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/utilities/actions.js